import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Hireservice.css';

const tabData = [
  {
    key: 'ai',
    label: 'AI & Software',
    description: 'Expert AI developers and software engineers ready to transform your digital solutions.',
    cards: [
      { title: 'AI Development', desc: 'Custom AI solutions, machine learning models, and intelligent automation.' },
      { title: 'Full-Stack Development', desc: 'End-to-end web and mobile application development with modern technologies.' },
      { title: 'Software Architecture', desc: 'Scalable software design and implementation for enterprise solutions.' }
    ],
    image: '/assets/images/industries/AI & Data Services.jpg'
  },
  {
    key: 'marketing',
    label: 'Digital Marketing',
    description: 'Strategic digital marketing experts to boost your online presence and drive growth.',
    cards: [
      { title: 'Social Media Management', desc: 'Strategic social media planning, content creation, and community engagement.' },
      { title: 'SEO Optimization', desc: 'Comprehensive SEO strategies to improve your search engine rankings.' },
      { title: 'Content Marketing', desc: 'Engaging content creation and marketing strategies for brand growth.' }
    ],
    image: '/assets/images/industries/Marketing.jpg'
  },
  {
    key: 'support',
    label: 'Customer Support Admin',
    description: 'Dedicated administrative professionals for exceptional customer service.',
    cards: [
      { title: 'Customer Service Excellence', desc: 'Professional customer support and inquiry management.' },
      { title: 'Administrative Support', desc: 'Comprehensive administrative tasks and office management.' },
      { title: 'Data Management', desc: 'Efficient data entry, processing, and organization.' }
    ],
    image: '/assets/images/industries/Support.jpg'
  },
  {
    key: 'team',
    label: 'Team Services',
    description: 'Build your dream remote team with our comprehensive staffing solutions.',
    cards: [
      { title: 'Team Building', desc: 'Strategic team assembly and management for remote operations.' },
      { title: 'Project Management', desc: 'Efficient project coordination and team leadership.' },
      { title: 'Resource Planning', desc: 'Strategic resource allocation and team scaling solutions.' }
    ],
    image: '/assets/images/industries/Team.jpg'
  }
];

const HireService = () => {
  const [activeTab, setActiveTab] = useState(tabData[0].key);
  const currentTab = tabData.find(tab => tab.key === activeTab);

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section className="hire-service-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-heading text-center">
              <h2 className="heading-text">
                Your Trusted Partner in Remote Staffing Solutions
              </h2>
            </div>
          </div>
        </div>

        <div className="service-tabs">
          <div className="tab-navigation">
            {tabData.map(tab => (
              <button 
                key={tab.key}
                className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <motion.div 
            className="service-content"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            key={activeTab}
          >
            <div className="service-layout">
              <div className="service-main-content">
                <motion.div 
                  className="service-info"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <h3>{currentTab.label}</h3>
                  <p>{currentTab.description}</p>
                </motion.div>

                <div className="service-cards">
                  {currentTab.cards.map((card, index) => {
                    // Map card titles to App.js routes
                    let url = '#';
                    if (currentTab.key === 'ai') {
                      if (card.title === 'AI Development') url = '/Aisoftware';
                      if (card.title === 'Full-Stack Development') url = '/Dedicated-developer';
                      if (card.title === 'Software Architecture') url = '/project-management';
                    } else if (currentTab.key === 'marketing') {
                      if (card.title === 'Social Media Management') url = '/Digitalmarkiting';
                      if (card.title === 'SEO Optimization') url = '/seo-optimization';
                      if (card.title === 'Content Marketing') url = '/content-writing';
                    } else if (currentTab.key === 'support') {
                      if (card.title === 'Customer Service Excellence') url = '/customer-support';
                      if (card.title === 'Administrative Support') url = '/admin-support';
                      if (card.title === 'Data Management') url = '/research-report';
                    } else if (currentTab.key === 'team') {
                      if (card.title === 'Team Building') url = '/remote-team-scaling';
                      if (card.title === 'Project Management') url = '/project-management';
                      if (card.title === 'Resource Planning') url = '/hire-dedicated-team';
                    }
                    return (
                      <Link to={url} key={index} style={{ textDecoration: 'none' }}>
                        <motion.div 
                          className="service-card"
                          variants={itemVariants}
                        >
                          <div className="service-card-content">
                            <div className="role-info">
                              <div className="role-details">
                                <h4>{card.title}</h4>
                                <p>{card.desc}</p>
                              </div>
                            </div>
                            <div className="service-card-arrow">
                              <i className="fas fa-arrow-right"></i>
                            </div>
                          </div>
                        </motion.div>
                      </Link>
                    );
                  })}
                </div>
              </div>

              <div className="service-image-section">
                <motion.div 
                  className="service-image-container"
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5 }}
                  key={activeTab}
                >
                  <img 
                    src={currentTab.image}
                    alt={currentTab.label}
                    className="service-feature-image"
                  />
                
                </motion.div>
                  <div >
                    {/* <div className="overlay-content"> */}
                      <h4 style={{ color: '#fff' }}>{currentTab.label}</h4>
                      <p style={{ color: '#fff' }}>{currentTab.description}</p>
                    {/* </div> */}
                  </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HireService;
